import styles from "./Card.module.scss";
import { classNames } from "@/shared/lib/classNames/classNames";

interface CardProps {
    text?: React.ReactNode;
    position?: string;
    photo?: string;
}

export const Card = ({ text, position, photo }: CardProps) => {
    return (
        <div className={classNames(styles.card, { [styles.padding]: !photo })}>
            {text && <div className={styles.text}>{text}</div>}
            {position && <div className={styles.position}>{position}</div>}
            {photo && (
                <div className={styles.photo}>
                    <img src={photo} />
                </div>
            )}
        </div>
    );
};
